import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageHistoryComponent } from 'src/app/popups/language-history/language-history.component';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, BusinessEnabledOption, BusinessWrapper, FileUploadFor, InteractionType, KeyValues3, KeyValues5, KeyValues5Sets, KeyValueSet, LanguageKeyType, LocalService, NumericConfig, PageKey, PrintHtml, ProductEntryType, QrLabelTemplateType, Status, Wrappers15, Wrappers20 } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';
import { SellerManagementService } from '../../../service/seller-management.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  FileUploadFor = FileUploadFor;
  lstSectionConfigKeys: string[] = ["table", "product_config"]; ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None; businessName = '';
  wrappers: Wrappers20; businessId: string = ''; business: BusinessWrapper = null; maxBodyHeight = 0; isActionPopupOpen = false;
  numericConfig: NumericConfig = { isDecimalAllowed: true, isNegativeAllowed: true } as NumericConfig; isInventoryEnabled: boolean = false; isDirectStockDisabled: boolean = true;
  selectedProductIdForImageUpload: string = ''; isImageUploadEnabled: boolean = false; isNotConsiderTax = true; isExcludePrice = false; isGlobalBarcode = false;
  isGalleryPopupOpen = false; isProductDetailPopupOpen = false; selectedProductId = ''; businessTaxes: KeyValues5Sets[] = []; taxCategories: KeyValues5[] = [];
  isOnlyLessStock = false; hasValidBatchDetails = false; lessStockMessage: string = ''; selectedTaxCategoryId = ''; productLabels: KeyValueSet[] = [];
  selectedMeasurementType: number = 0; selectedProductName: string = ''; selectedProductCode: string = ''; isRawInventoryEnabled = false;

  selectedTemplateFor = QrLabelTemplateType.Product; isOpenLabelPreviewSettings = false; printHtml: PrintHtml; filterData: any;
  isOpenCustomFields = false; isOpenChildMeasurement = false; customFields: KeyValues5[] = []; isRawMaterialInventoryConfigOpen = false;
  selectedProductEntryType: string = ProductEntryType.Billing.toString(); productEntryTypes: KeyValueSet[] = []; productCategories: KeyValues3[] = []; selectedProductCategory: string = '';

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService, private route: ActivatedRoute, private modalService: NgbModal, private sellerManagementService: SellerManagementService, private router: Router, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.configurationManagementService.ensurePageActions(PageKey.Products, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.userId = routeParams.userId;
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onSetCustomFields();
    this.onLoad(true);
  }

  isLoading = false;
  onLoad(isForce = false) {
    if (!this.isLoading) {
      this.isLoading = true;
      if (isForce) {
        this.onGetBusiness();
      }
      this.productManagementService.getProducts(this.businessId, this.isInventoryEnabled && this.isOnlyLessStock, this.selectedProductCategory, !this.wrappers ? null : this.wrappers.paging, '', parseInt(this.selectedProductEntryType)).subscribe(result => {
        this.hasValidBatchDetails = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsEnableBatchDetails);
        this.wrappers = result;
        if (this.wrappers.configValues) {
          this.productEntryTypes = this.wrappers.configValues;
        }
        if (this.wrappers.productCategories) {
          this.productCategories = this.wrappers.productCategories;
        }
        if (this.wrappers.lessStockCount && this.wrappers.lessStockCount > 0) {
          if (this.localService.languageContent && this.localService.languageContent.table) {
            this.lessStockMessage = this.localService.replaceAll(this.localService.languageContent.table.less_stock_count, '##', this.wrappers.lessStockCount.toString());
          }
        } else {
          this.lessStockMessage = '';
        }
        this.isLoading = false;
      });
    }
  }

  onGetBusiness(isForce = false) {
    if (this.business == null || isForce) {
      this.sellerManagementService.getBusiness(this.businessId).subscribe(result => {
        this.business = result;
        this.isImageUploadEnabled = this.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.HasImage && x.isSelected).length > 0;
        this.isInventoryEnabled = this.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.HasInventory && x.isSelected).length > 0;
        this.isDirectStockDisabled = this.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.DisableDirectStockEntry && x.isSelected).length > 0;
        this.isNotConsiderTax = this.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.ConsiderBaseAmountAsTaxInCludedAmount && x.isSelected).length > 0;
        this.isExcludePrice = this.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.IsExcludedPricingEnabled && x.isSelected).length > 0;
        this.isGlobalBarcode = this.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.GlobalProdcutBarCode && x.isSelected).length > 0;
        this.businessTaxes = this.business.taxesFull;
        this.taxCategories = this.business.taxCategories;
        this.productLabels = this.business.productLabels.filter(x => x.isSelected);
        this.businessName = this.business.content.v10;
      });
    }
  }

  onSetCustomFields() {
    this.productManagementService.getCustomFields(this.businessId, true).subscribe(result => {
      this.customFields = result;
    });
  }

  onEnableDiableStock() {
    this.sellerManagementService.activeInactiveStatus(this.businessId, ActiveInactiveFor.StockManagment).subscribe(result => {
      if (result.status == Status.Success) {
        this.isOnlyLessStock = false;
        this.sellerManagementService.onRefreshBusiness(this.businessId);
        this.onGetBusiness(true);
      }
    });
  }


  onActiveInactiveStatus(strId: string) {
    this.productManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Product).subscribe(result => {
      if (result.status == Status.Success) {
        const updatedItem = this.wrappers.items.find(x => x.key == strId);
        updatedItem.v3 = result.id;
      }
    });
  }

  onGenerateBarCode() {
    this.filterData = {
      isOnlyLessStock: this.isOnlyLessStock,
      paging: this.wrappers.paging
    }
    this.isOpenLabelPreviewSettings = true;
  }

  onHtmlGenerated(html: PrintHtml) {
    this.isOpenLabelPreviewSettings = false;
    this.printHtml = html;
  }

  onUploadImage(strId: string) {
    this.selectedProductIdForImageUpload = strId;
    this.isGalleryPopupOpen = true;
  }

  onClosesGalleryPopup(e: any) {

  }

  onClosesProductDetailPopup(e: any) {
    this.onLoad();
  }

  onAddStock(event, key, currentVal) {
    if (event.target.value != null && event.target.value != '') {
      let data = { key: key, value: event.target.value } as KeyValueSet;
      this.productManagementService.addStock(data).subscribe(result => {
        this.localService.showInformationByStatus(result.status, result.status != Status.Success);
        if (result.status == Status.Success) {
          this.wrappers.items.find(x => x.key == key).v5 = parseFloat(currentVal) + parseFloat(event.target.value);
          event.target.value = null;
        }
      });
    }
  }

  onAction(index, productId = '', key1 = '', key2 = '', key3 = '') {
    switch (index) {
      case 1: {
        this.productManagementService.downloadProducts(this.businessId, this.ctryCode).subscribe(result => {
          if (result.length > 0) {
            this.localService.onDownloadFile(result, 'Products');
          }
        });
        // this.productManagementService.getUsageLimits(this.businessId, UsageLimitType.BulkDownloadProduct).subscribe(result => {
        //   if (result.length != 0) {
        //     this.productManagementService.downloadProducts(this.businessId, this.ctryCode).subscribe(result => {
        //       if (result.length > 0) {
        //         this.localService.onDownloadFile(result, 'Products');
        //       }
        //     });
        //   } else {
        //     const modalRef = this.modalService.open(UsageLimitsComponent);
        //     modalRef.componentInstance.items = result;
        //   }
        // });
      } break;
      case 2: {
        this.router.navigate(['/product-logs' + this.localService.basicParamsString, this.businessId]);
      } break;
      case 3: {
        const modalRef = this.modalService.open(LanguageHistoryComponent);
        modalRef.componentInstance.parentId = productId;
        modalRef.componentInstance.languageKeyType = LanguageKeyType.ProductName;
      } break;
      case 4: {
        this.selectedProductId = productId;
        this.isProductDetailPopupOpen = true;
      } break;
      case 5: {
      } break;
      case 6: {
        this.router.navigate(['/batch-inventories' + this.localService.basicParamsString, this.businessId, productId]);
      } break;
      case 7: {
        this.isOpenCustomFields = true;
      } break;
      case 8: {
        this.selectedProductId = productId;
        const product = this.wrappers.items.find(x => x.key == productId);
        this.selectedMeasurementType = parseInt(key1 ?? '0');
        this.selectedProductName = key2;
        this.selectedProductCode = key3;
        this.selectedTaxCategoryId = product.v15;
        this.isOpenChildMeasurement = true;
      } break;
      case 9: {
        this.isActionPopupOpen = true;
      } break;
      case 10: {
        this.selectedProductId = productId;
        const product = this.wrappers.items.find(x => x.key == productId);
        this.selectedMeasurementType = parseInt(key1 ?? '0');
        this.selectedProductName = key2;
        this.selectedProductCode = key3;
        this.isRawInventoryEnabled = product ? (product.v16 == '1') : false;
        this.isRawMaterialInventoryConfigOpen = true;
      } break;
    }
  }
}
